import { Pie } from "@ant-design/charts"

type PieChartData = {
  type: string
  value: number
}

export type Props = {
  data: PieChartData[]
}

const PieChart = ({data} : Props) => {
  if(data.length <= 0)
    return <></>

  const config = {
    height: 276,
    width: 440,
    data: data,
    angleField: 'value',
    colorField: 'type',
    label: {
      text: 'type',
      style: {
        fontWeight: 'bold',
      },
    },
    style: {
      stroke: '#fff',
      inset: 1,
    },
    tooltip: {
      title: 'type',
    },
    legend: {color: {position: 'bottom'}},
    scale: {
      size: { range: [12, 20] },
      color: { range: ['green', 'red', 'lightgrey'] },
    },
  };

  return <Pie {...config} />
}

export default PieChart